import { useTranslation } from 'react-i18next';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import { validateSystemName } from 'features/systems/domain/queries/systems-queries';

type SystemInformationHook = {
  validateName: (systemName: string, id?: string) => Promise<boolean | string>;
};

const useSystemInformation = (): SystemInformationHook => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  const { t } = useTranslation('systems');

  const validateName = async (systemName: string, id?: string): Promise<boolean | string> => {
    try {
      await validateSystemName(authenticatedInstance, {
        id,
        name: systemName,
      });
      return true;
    } catch {
      return t('details.information.uniqueNameHelperText');
    }
  };

  return {
    validateName,
  };
};

export default useSystemInformation;
